import enUsStrings from "common/assets/nls/en-us/common";
import enUsFormatting from "common/assets/nls/en-us/formatting";

const language = function(strings, formatting) {
    return {
        strings,
        formatting
    }
};

const nls = {
    "en-us": language(enUsStrings, enUsFormatting)
}

nls.getStrings = function(lang) {
    return nls[lang].strings;
}

nls.getFormatting = function(lang) {
    return nls[lang].formatting;
}

export default nls;
